<template>
	<div class="innerBox">
		<h2>KPI</h2>
		<panel class="border border-secondary" :noExpand="true">
			<template slot="header">
				<h4 class="panel-title">Filter</h4>
			</template>
			<!-- {{options}} -->
			<div class="row outerBox filterBox" style="padding:0">
				<div class="col row">
				
				<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
					<label for="partshopCode">Bulan</label>
					<Multiselect
						:options="options.month.map(x => x.value)"
						:custom-label="opt => options.month.find(x => x.value == opt).name"
						v-model="filter.month"
						placeholder="Pilih Tipe Sparepart"
					/>
					
				</div>
				<div class="col-md-3" :class="mobile ? 'pt-20' : ''">
					<label for="partshopCode">Tahun</label>
					<Multiselect
						:options="options.year"
						v-model="filter.year"
						placeholder="Pilih Tipe Sparepart"
					/>
					
				</div>
				<div class="col-md-3" style="display: flex; flex-direction: column-reverse" :class="mobile ? 'pt-20' : ''">
					<button type="button" class="btn btn-primary" style="height:43px; margin-bottom:1.5%" @click="search()">Filter</button>
				</div>
				</div>
			</div>
		</panel>

		<div class="row mt-3 ">
			<div class="col-md-8 col-12 order-2 order-md-1 mt-3 pr-3">
				<panel class="border border-secondary rounded" :noButton="true">
					<template slot="header">
						<h4 class="panel-title">Statistika Bulan {{options.month.find(x => x.value == filter.month).name}} {{filter.year}}</h4>
					</template>
					<!-- <span></span> -->
					<div class="row">
						<div class="col-md col-12 mt-2">
							<label>Pengiritan Bahan</label>
							<h4 v-if="averageData">{{averageData.find(x => x.kpi_type_id == 2) ? numberWithCommas(averageData.find(x => x.kpi_type_id == 2).average) : '-'}} Gram</h4>
							<h4 v-else>Loading....</h4>
						</div>
						<div class="col-md col-12 mt-2">
							<label>Rata Rata Pengerjaan Step Bengkel</label>
							<h4 v-if="averageData">
								{{averageData.find(x => x.kpi_type_id == 3) ? numberWithCommas(averageData.find(x => x.kpi_type_id == 3).average) : '-'}} Menit 
								<i class="fa fa-info-circle" id="averageTime"></i>
								<b-popover target="averageTime" title="Rata Rata Pengerjaan Per Step Bengkel" triggers="hover focus" placement="bottom" >
									<!-- <span v-html="singleRow.content"></span> -->

									<table class="table table-bordered text-center">
										<thead class="thead-dark">
											<th>Nama Step Bengkel</th>
											<th>Rata Rata Waktu Pengerjaan</th>
										</thead>
										<tbody v-for="step in averageWorkingTime" :key="step.name">
											<tr>
												<td>{{step.step_name}}</td>
												<td>{{numberWithCommas(step.average)}} Menit</td>
											</tr>
										</tbody>
									</table>
								</b-popover>

							</h4>
							<h4 v-else>Loading....</h4>
						</div>
						<div class="col-md col-12 mt-2">
							<label>Total Step Bengkel</label>
							<h4 v-if="averageData">{{totalSteps ? numberWithCommas(totalSteps) : '-'}}</h4>
							<h4 v-else>Loading....</h4>
						</div>
					</div>
				</panel>

				<div style="display:block;overflow-x:scroll">

					<table class="table text-center">
						<thead class="thead-dark">
							<th>No.</th>
							<th>Nama</th>
							<!-- <th>Dekripsi Pekerjaan</th> -->
							<th>Pengiritan Bahan</th>
							<th>Rata Rata Waktu Pengerjaan</th>
							<th>Total Step Bengkel</th>
							<th>KPI</th>
						</thead>
						<tbody v-for="(data, index) in overviewData" :key="index">
							<tr>
								<td>{{index + 1}}</td>
								<td>{{data.name}}</td>
								<!-- <td class="pre-formatted">{{data.labourer_type_names ? data.labourer_type_names.split(',').join('\n') : '-'}}</td> -->
								<td>{{numberWithCommas(data.save_bahan)}} Gram</td>
								<td>{{numberWithCommas(data.working_speed)}} Menit</td>
								
								<td>{{numberWithCommas(data.steps_done)}}</td>
								<td>{{parseFloat(data.kpi).toFixed(2)}}</td>
							</tr>
						</tbody>
						
					</table>
				</div>
			</div>
			<div class="col-md-4 col-12 order-1 order-md-2 mt-3 pr-3">
				<panel class="border border-secondary rounded" :noExpand="true">
					<template slot="header">
						<h4 class="panel-title">Detail KPI</h4>
					</template>

					<table class="table table-borderless" v-if="kpiTypes">
						<thead style="border-bottom : 1px solid black">
							<th>Nama Tipe</th>
							<th>Multiplier</th>
						</thead>
						<tbody>
							<tr v-for="(type,index) in kpiTypes" :key="type.name">
								<th>{{type.name}}</th>
								<td v-if="!editKpi">{{type.multiplier}}</td>
								<td v-else>
									<!-- {{type.multiplier}} -->
									<input class="form-control" type="text" v-model="editObj[index].multiplier" />
								</td>
							</tr>
						</tbody>
						<tbody>
							<tr class="text-center">
								<td colspan="2" v-if="!editKpi">
									<button class="btn btn-primary w-50" @click="changeKPI()">Ubah</button>
									
								</td>
								<template v-else>
									<td><button class="btn btn-success " style="width:100px;" @click="saveKPI()">Simpan</button></td>
									<td><button class="btn btn-danger" style="width:100px;" @click="editKpi = false">Batal</button></td>
								</template>
							</tr>
						</tbody>
					</table>
					<h4 v-else>Loading.....</h4>
				</panel>
			</div>
		</div>
	</div>
</template>

<script>
import moment from "moment"

import Multiselect from 'vue-multiselect'

import Stats from './children/smallStats.vue'

export default {
	components : {
		Multiselect,
		Stats
	},
	data () {
		return {
			mobile : this.isMobile(),
			options : this.$store.getters.getFilterOptions,
			filter : {
				month : new moment().subtract(1, 'months').format('M'),
				year : new moment().subtract(1, 'months').format("YYYY")
			},
			overviewData : null,
			averageData : null,
			averageWorkingTime : null,
			kpiTypes : null,
			editKpi : false,
			editObj : null,
			totalSteps : '-'
		}
	},
	mounted () {
		
		this.getAverage()
		this.getAverageWorkingTime()
		this.getKPITypes()
	},
	methods : {
		search () {
			this.getAverage()
			this.getAverageWorkingTime()
			this.getKPITypes()
		},
		async saveKPI () {
			let data = this.editObj
			let message = []
			let flag = true

			for(var i = 0 ; i < data.length ; i++) {
				let curData = {
					multiplier : data[i].multiplier
				}
				let url = '/api/v1/labourer/kpi/types/' + data[i].id

				try {
					let resp = await this.$http.put(url , curData)
					message.push('KPI ' + data[i].name + ' Berhasil Diubah')
					
				}
				catch(err) {
					flag = false
					console.log(err)
				}
			}

			this.$store.dispatch('triggerAlert' , [flag , message])
			this.editKpi = false
			this.getKPITypes()
		},
		changeKPI () {
			this.editKpi = true
			this.editObj = JSON.parse(JSON.stringify(this.kpiTypes))
		},
		getKPITypes() {
			
			let url = `/api/v1/labourer/kpi/types`

			this.$http.get(url)
			.then((resp) => {
				this.kpiTypes = resp.data.data
				this.getOverview()
			}) 
			.catch((err) => {
				console.log(err)
			})
		},
		getOverview() {
			let url = `/api/v1/kpi/?month=${this.filter.month}&year=${this.filter.year}`

			this.$http.get(url)
			.then((resp) => {
				this.overviewData = resp.data.data

				for(var i =0 ; i < this.overviewData.length ; i++) {
					let curData = this.overviewData[i]

					let kpiPengiritan = parseFloat(curData.save_bahan) * parseFloat(this.kpiTypes.find(x => x.id == 2).multiplier)
					let kpiSpeed = parseFloat(curData.working_speed) * parseFloat(this.kpiTypes.find(x => x.id == 3).multiplier)
					let kpiWorkDone = parseFloat(curData.steps_done) * parseFloat(this.kpiTypes.find(x => x.id == 4).multiplier)
					curData.kpi = kpiPengiritan + kpiSpeed + kpiWorkDone 
				}
			}) 
			.catch((err) => {
				console.log(err)
			})
		},
		getAverage() {
			let url = `/api/v1/kpi/average?month=${this.filter.month}&year=${this.filter.year}`

			this.$http.get(url)
			.then((resp) => {
				let data = resp.data.data

				this.totalSteps = data.totalSteps

				this.averageData = data.averages
			}) 
			.catch((err) => {
				console.log(err)
			})
		},
		getAverageWorkingTime() {
			let url = `/api/v1/kpi/average/working-time?month=${this.filter.month}&year=${this.filter.year}`

			this.$http.get(url)
			.then((resp) => {
				this.averageWorkingTime = resp.data.data
			}) 
			.catch((err) => {
				console.log(err)
			})
		}
	}
}
</script>

<style scoped>
	.pre-formatted {
		white-space: pre;
	}

	th {
		vertical-align: middle;
	}
</style>